import { map, merge, find } from 'lodash';

/* Create the initial state for the form form the retrieved answers */
const answersFromAppraisal = (appraisal, answers) => {
  const { QAAnswers } = answers; // state.Appraisal.appraisalAnswers[props.router.params.appraisalId][isManager ? 'managerAnswers' : 'employeeAnswers'];
  const { QAElements } = appraisal.PMForm;
  let storageData = null;

  /*
      Logic to check if we have saved form data in local storage.
      If we find data in local storage we prefer to load that
      since it should only remain in local stoage if saving
      did not succeed
    */
  const appraisalId = appraisal.PMAppraisalID;
  const { appraisals } = localStorage;
  if (appraisals) {
    storageData = JSON.parse(appraisals);
    if (!storageData[appraisalId] || storageData[appraisalId].expires < Date.now()) {
      storageData = null;
    } else {
      storageData = storageData[appraisalId];
    }
  }

  const elems = map(
    QAAnswers,
    ({
      QAElementID,
      QAAnswerText,
      QAAnswerValue,
      QAAnswerComment,
    }) => {
      const { QAInput } = find(QAElements, ['QAElementID', QAElementID]);
      if (!QAInput) { return {}; }
      const { QAInputAnswerType } = QAInput;
      const key = `${QAInputAnswerType}-${QAElementID}${(QAInputAnswerType === 3 ? `-${btoa(QAAnswerText)}` : '')}`;
      if (QAInputAnswerType === 3) {
        return { [key]: QAAnswerValue === 'true', [`COMMENT-${QAInputAnswerType}-${QAElementID}`]: QAAnswerComment };
      } else if (QAInputAnswerType === 2 || QAInputAnswerType === 6) {
        return { [key]: Number(QAAnswerValue), [`COMMENT-${QAInputAnswerType}-${QAElementID}`]: QAAnswerComment };
      }
      return { [key]: QAAnswerValue, [`COMMENT-${QAInputAnswerType}-${QAElementID}`]: QAAnswerComment };
    },
  );
    // Merge the array of fields into one state object.
  const mergeElems = merge(...elems);
  // saveToStorage(mergeElems, appraisalId);
  // Check if the
  return storageData || mergeElems;
};

export default (state, props) => {
  const appraisal = state.Appraisal.appraisalsById[props.router.params.appraisalId];
  if (!appraisal) { return undefined; }
  const answers = state.Appraisal.appraisalAnswers[props.router.params.appraisalId];
  const {
    EmployeeDueDate, ManagerStatus, EmployeeStatus,
  } = appraisal;
  const empDue = new Date(EmployeeDueDate);
  empDue.setHours(23, 59, 59);
  const showAnswers = (ManagerStatus === 2 && EmployeeStatus === 2) || (ManagerStatus === 2 && (empDue.getTime() < Date.now()));
  if (showAnswers) {
    const final = answersFromAppraisal(appraisal, answers.finalAnswers);
    const manager = answersFromAppraisal(appraisal, answers.managerAnswers);
    // Merge the manager answers into the final ones.
    return merge(manager, final);
  }
  return answersFromAppraisal(appraisal, answers.employeeAnswers);
};



// WEBPACK FOOTER //
// ./src/containers/utils/answersToFormState.js